import { useGetCompanyQuery } from "features/api/company"
import { useFlags } from "features/api/flags"

export function useIsGeneralizeDepositsCloseOutsEnabled(): boolean {
  const { GENERALIZE_DEPOSITS_CLOSE_OUTS } = useFlags()
  const { data } = useGetCompanyQuery({})
  return (
    GENERALIZE_DEPOSITS_CLOSE_OUTS.boolVal &&
    !!data?.company?.isDepositsAndPartialFulfillmentEnabled
  )
}
